import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const useMyAgenda = ({
  from,
  tz,
  user_tz
}: {
  from?: string;
  tz?: string;
  user_tz: string;
}) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["myAgenda", tz, user_tz, from],
    queryFn: async () => {
      const response = await apiClient.agenda.getMyAgenda({
        ...(tz ? { tz } : {}),
        user_tz,
        from
      });
      if (response.ok) {
        return response.result;
      }
      return null;
    },
    enabled: !!user_tz
  });
};
